import { useState, useEffect } from "react";

export default function SplashScreen() {
  const [visible, setVisible] = useState(() => !sessionStorage.getItem("splash_seen"));
  const [fading, setFading] = useState(false);

  useEffect(() => {
    if (!visible) return;
    const t1 = setTimeout(() => setFading(true), 2000);
    const t2 = setTimeout(() => {
      sessionStorage.setItem("splash_seen", "1");
      setVisible(false);
    }, 2600);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [visible]);

  if (!visible) return null;

  return (
    <div
      data-testid="splash-screen"
      className={`fixed inset-0 z-[999] flex items-center justify-center bg-[#570B18] transition-opacity duration-700 ${fading ? "opacity-0" : "opacity-100"}`}
    >
      <div className="pointer-events-none absolute left-6 top-6 h-16 w-16 border-l-2 border-t-2 border-gold/30" aria-hidden="true" />
      <div className="pointer-events-none absolute bottom-6 right-6 h-16 w-16 border-b-2 border-r-2 border-gold/30" aria-hidden="true" />
      <img
        src="/assets/logo.png"
        alt="ENPALSBOX — Musical Association"
        data-testid="splash-logo"
        className="w-72 max-w-[80vw] animate-scale-in drop-shadow-[0_10px_40px_rgba(0,0,0,0.5)] sm:w-96"
      />
    </div>
  );
}
